import { isAssistantIndexJobView } from "@/lib/ai/assistant-index-job-types";
import { useAssistantIndexStore } from "@/stores/assistant-index-store";

export function receiveAssistantIndexJobEvent(value: unknown): boolean {
    if (!isAssistantIndexJobView(value)) return false;
    useAssistantIndexStore.getState().upsert(value);
    return true;
}
